import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export enum Localization {
  it = "it",
  en = "en",
}

export enum ThemeColor {
  light = "LIGHT",
  dark = "DARK",
}

export enum ThemeMode {
  DEFAULT = "DEFAULT",
  KIOSK = "KIOSK",
  KIOSKADMIN = "KIOSKADMIN",
}

export type ThemeState = {
  language: string;
  theme: ThemeColor;
  popupSearch: boolean;
  popupSupport: boolean;
  showLoading: boolean;
  sidebarStatus: boolean;
  showLoginPopup: boolean;
  showPinForm: boolean;
  footerStatus: boolean;
  isMobile: boolean;
  isTablet: boolean;
  headerStatus: boolean;
  mode: ThemeMode;
  showBackgroundImage: boolean;
  showHomeBg: boolean;
};

const storageLanguage = JSON.parse(localStorage.getItem("language"));
const ls = localStorage.getItem("barsandfooter");
const { footer, header } = ls
  ? JSON.parse(localStorage.getItem("barsandfooter"))
  : true;

const initialState: ThemeState = {
  language: storageLanguage ? storageLanguage : "en",
  theme: ThemeColor.light,
  popupSearch: false,
  popupSupport: false,
  showLoading: false,
  sidebarStatus: true,
  showLoginPopup: false,
  footerStatus: footer ? footer : false,
  isMobile: false,
  isTablet: false,
  headerStatus: header ? header : true,
  mode: ThemeMode.DEFAULT,
  showBackgroundImage: false,
  showHomeBg: false,
  showPinForm: false,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setThemeColor: (
      state: { theme: ThemeColor },
      action: PayloadAction<ThemeColor>
    ) => {
      state.theme = action.payload;
    },
    setThemeLocale: (
      state: { language: string },
      action: PayloadAction<string>
    ) => {
      localStorage.setItem("language", JSON.stringify(action.payload));
      state.language = action.payload;
    },
    showSearchPopup: (
      state: { popupSearch: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.popupSearch = action.payload;
    },
    showSupportPopup: (
      state: { popupSupport: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.popupSupport = action.payload;
    },
    showLoading: (
      state: { showLoading: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.showLoading = action.payload;
    },

    openSidebar: (
      state: { sidebarStatus: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.sidebarStatus = action.payload;
    },

    showLoginPopup: (
      state: { showLoginPopup: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.showLoginPopup = action.payload;
    },

    showFooter: (
      state: { footerStatus: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.footerStatus = action.payload;
    },

    showHeader: (
      state: { headerStatus: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.headerStatus = action.payload;
    },

    setIsMobile: (state: ThemeState, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },

    setIsTablet: (state: ThemeState, action: PayloadAction<boolean>) => {
      state.isTablet = action.payload;
    },

    setMode: (state: ThemeState, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload;
    },
    setShowPinForm: (state: ThemeState, action: PayloadAction<boolean>) => {
      state.showPinForm = action.payload;
    },

    setShowBackgroudImage: (
      state: ThemeState,
      action: PayloadAction<boolean>
    ) => {
      state.showBackgroundImage = action.payload;
    },
    setShowHomeBg: (state: ThemeState, action: PayloadAction<boolean>) => {
      state.showHomeBg = action.payload;
    },
  },
});

export const {
  setThemeColor,
  setThemeLocale,
  showSearchPopup,
  showSupportPopup,
  showLoading,
  openSidebar,
  showLoginPopup,
  showFooter,
  setIsMobile,
  showHeader,
  setMode,
  setShowBackgroudImage,
  setShowHomeBg,
  setIsTablet,
  setShowPinForm,
} = themeSlice.actions;
export const selectTheme = (state: RootState) => state.theme;
export default themeSlice.reducer;
